import { TypedDocumentNode, gql } from '@apollo/client';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';

import { PlayerScore } from 'components/card/USSports/PlayerScore';

import { LastNBAGame_nbaPlayer } from './__generated__/index.graphql';

type Props = {
  player: LastNBAGame_nbaPlayer;
};

export const LastNBAGame = ({ player }: Props) => {
  const lastNBAGame = player.lastNBAGame?.[0];
  const score = lastNBAGame?.score;
  if (!score || !lastNBAGame?.playedInGame) {
    return null;
  }
  return (
    <Horizontal center>
      <PlayerScore score={score} />
      vs
      <Tooltip title={lastNBAGame.againstTeam.fullName}>
        <img
          height="24"
          src={lastNBAGame.againstTeam.svgUrl}
          alt={lastNBAGame.againstTeam.fullName}
        />
      </Tooltip>
    </Horizontal>
  );
};

LastNBAGame.fragments = {
  nbaPlayer: gql`
    fragment LastNBAGame_nbaPlayer on NBAPlayer {
      slug
      lastNBAGame: latestFinalGameStats(last: 1) {
        playedInGame
        score
        againstTeam {
          slug
          fullName
          svgUrl
        }
      }
    }
  ` as TypedDocumentNode<LastNBAGame_nbaPlayer>,
};
